import {
  isOnboardingRoute,
  isWelcomeRoute,
} from "@/src/hooks/onboarding/isOnboardingRoute";

/**
 * Detail 二级 WebView 是否应禁止原生手势 / 系统返回关闭容器。
 * 与 onboarding 沉浸式流程对齐：进入 welcome / onboarding 后不可手势退出。
 */
export function shouldDisableDetailGestureBack(pathname: string): boolean {
  return isWelcomeRoute(pathname) || isOnboardingRoute(pathname);
}

/** 主壳 WebView 内 welcome / onboarding 是否应禁止系统返回（与 Detail 沉浸式策略一致）。 */
export function shouldDisableShellImmersiveBack(pathname: string): boolean {
  return shouldDisableDetailGestureBack(pathname);
}
